import React, {Component} from 'react';
import '../../../../style/searchAccount.css'
import {Link} from "react-router-dom";
import BuildingContext from "../../../../contexts/Building";
import Skeleton from "react-loading-skeleton";
import FormControl from "@mui/material/FormControl";
import {Box, Button, CircularProgress, MenuItem, Select} from "@mui/material";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import {red} from "@mui/material/colors";
import {MdOutlineDeleteOutline, MdOutlineEdit} from "react-icons/md";
import { API_BASE_URL } from '../../../../api/client';
import {downloadCsv} from '../../../../utils/csvExport';
import ListPagination, {paginateItems} from '../../../CustomInputs/ListPagination';
import {depositBucket, guestStayDateIssue} from '../../../../utils/dashboardGuestStats';

const depositStatus = (dateStr) => {
    const bucket = depositBucket(dateStr);
    return bucket === 'missing' ? null : bucket;
};

class SearchAccount extends Component {
    static contextType = BuildingContext;
    searchRequestId = 0;
    searchTimer = null;

    state = {
        searchLoading: true,
        deleteLoading: false,
        placeholder: '',
        accountFound: [],
        searchInput: "",
        searchType: "fullName",
        selectedAccount: {},
        showDeleteModal: false,
        residenceStatusFilter: '',
        depositFilter: '',
        guestDateFilter: '',
        listPage: 1,
        pageSize: 20,
    }

    componentDidMount() {
        this.setState(this.readFiltersFromUrl(), () => this.loadPeople(''));
    }

    componentDidUpdate() {
        const next = this.readFiltersFromUrl();
        if (
            next.depositFilter !== this.state.depositFilter
            || next.guestDateFilter !== this.state.guestDateFilter
        ) {
            this.setState({...next, listPage: 1});
        }
    }

    isGuestPerson = (a) => a?.personType === 'familyGuest' || a?.personType === 'otherGuest';

    readFiltersFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            depositFilter: params.get('depositFilter') || '',
            guestDateFilter: params.get('guestDateFilter') || '',
        };
    };

    filterPeople = (list) => (list || []).filter((a) => {
        if (this.state.residenceStatusFilter && a.personType !== this.state.residenceStatusFilter) {
            return false;
        }
        if (this.state.depositFilter) {
            // Deposit stats on dashboard are guest-only
            if (!this.isGuestPerson(a)) return false;
            const bucket = depositBucket(a.depositReturnDate);
            if (this.state.depositFilter === 'missing' && bucket !== 'missing') return false;
            if (this.state.depositFilter === 'overdue' && bucket !== 'overdue') return false;
            if (this.state.depositFilter === 'soon' && bucket !== 'soon') return false;
        }
        if (this.state.guestDateFilter === 'missingStay') {
            if (!this.isGuestPerson(a) || !guestStayDateIssue(a)) return false;
        }
        return true;
    });

    componentWillUnmount() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchRequestId += 1;
    }

    authHeaders = () => ({'Authorization': localStorage.getItem('accessToken')});

    refreshTokenAndRetry = async (requestFn) => {
        const role = localStorage.getItem('role');
        const refreshUrl = role === 'MANAGER'
            ? `${API_BASE_URL}/api/v1/manager/token/refresh`
            : role === 'SUPERVISOR'
                ? `${API_BASE_URL}/api/v1/supervisor/token/refresh`
                : null;
        if (!refreshUrl) return null;
        const response = await axios.get(refreshUrl, {
            headers: {'Authorization': localStorage.getItem('refreshToken')}
        });
        if (!response.headers["accesstoken"]) {
            window.location = '/';
            return null;
        }
        localStorage.setItem("accessToken", response.headers["accesstoken"]);
        return requestFn();
    }

    loadPeople = async (querySuffix = '') => {
        const requestId = ++this.searchRequestId;
        this.setState({searchLoading: true});
        const url = `${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Person${querySuffix}`;

        try {
            let data;
            try {
                data = await axios.get(url, {headers: this.authHeaders()}).then(r => r.data);
            } catch (e) {
                data = await this.refreshTokenAndRetry(
                    () => axios.get(url, {headers: this.authHeaders()}).then(r => r.data)
                );
            }
            if (requestId !== this.searchRequestId || data == null) return;
            this.setState({accountFound: Array.isArray(data) ? data : [], searchLoading: false});
            await this.enrichBedLocations(data, requestId);
        } catch (e) {
            if (requestId === this.searchRequestId) {
                this.setState({searchLoading: false});
            }
        }
    }

    personTypeLabel = (t) => {
        switch (t) {
            case 'constant':
                return 'اقامتگر ثابت';
            case 'familyGuest':
                return 'بستگان درجه یک';
            case 'otherGuest':
                return 'متفرقه';
            default:
                return '—';
        }
    }

    render() {
        return (
            <>
                <div className="page-title-row">
                    <h4>
                        اشخاص
                    </h4>
                    <div className="page-actions">
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-success"
                            onClick={this.exportExcel}
                        >
                            خروجی اکسل
                        </button>
                        <Link className="back-btn" to="/dashboard">
                            بازگشت
                            <i className="bi bi-caret-left-fill"/>
                        </Link>
                    </div>
                </div>
                <div className="search-box search-toolbar">
                    <div className="search-field">
                        <span className="search-field-label">براساس</span>
                        <FormControl fullWidth size="small">
                            <Select
                                className="search-select"
                                value={this.state.searchType}
                                onChange={(e) => {
                                    const searchType = e.target.value;
                                    this.setState({searchType, listPage: 1});
                                    const q = (this.state.searchInput || '').trim();
                                    if (q) {
                                        this.loadPeople(`&${searchType}=${encodeURIComponent(q)}`);
                                    }
                                }}
                                displayEmpty
                            >
                                <MenuItem value={"fullName"}>نام و نام خانوادگی</MenuItem>
                                <MenuItem value={"nationalCode"}>کد ملی</MenuItem>
                                <MenuItem value={"phoneNumber"}>شماره تلفن</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="search-field search-field-grow">
                        <span className="search-field-label">جستجو</span>
                        <div className="search-input-wrap">
                            <i className="bi bi-search" aria-hidden="true"/>
                            <input
                                type="text"
                                id="inputSearch"
                                placeholder="نام، کد ملی یا شماره تلفن…"
                                value={this.state.searchInput}
                                onChange={(e) => this.handleSearchInput(e)}
                            />
                        </div>
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">وضعیت اقامت</span>
                        <FormControl fullWidth size="small">
                            <Select
                                className="search-select"
                                value={this.state.residenceStatusFilter}
                                onChange={(e) => this.setState({residenceStatusFilter: e.target.value, listPage: 1})}
                                displayEmpty
                            >
                                <MenuItem value={""}>همه</MenuItem>
                                <MenuItem value={"constant"}>اقامتگر ثابت</MenuItem>
                                <MenuItem value={"familyGuest"}>بستگان درجه یک</MenuItem>
                                <MenuItem value={"otherGuest"}>متفرقه</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                {(this.state.depositFilter || this.state.guestDateFilter) ? (
                    <div className="alert alert-info py-2 px-3 mb-3 small">
                        {this.state.depositFilter === 'overdue' && 'فقط اشخاص با عودت ودیعه گذشته‌موعد'}
                        {this.state.depositFilter === 'soon' && 'فقط اشخاص با عودت ودیعه در ۷ روز آینده'}
                        {this.state.depositFilter === 'missing' && 'فقط مهمانان بدون تاریخ عودت ودیعه'}
                        {this.state.guestDateFilter === 'missingStay' && 'فقط مهمانان با تاریخ شروع یا پایان اقامت ناقص'}
                        {' '}
                        <Link to="/dashboard/people">حذف فیلتر</Link>
                    </div>
                ) : null}
                <div className="table-box">
                    <table className="table">
                        <thead>
                        <tr>
                            <th>نام</th>
                            <th>تلفن</th>
                            <th>کد ملی</th>
                            <th>نوع اقامت</th>
                            <th>موقعیت تخت</th>
                            <th>عودت ودیعه</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.searchLoading ?
                                [...Array(5)].map((x, i) => (
                                    <tr key={i}>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                    </tr>
                                ))
                                :
                                (() => {
                                    const filtered = this.filterPeople(this.state.accountFound);
                                    const {pageItems} = paginateItems(
                                        filtered, this.state.listPage, this.state.pageSize
                                    );
                                    if (pageItems.length === 0) {
                                        return (
                                            <tr className="table-empty-row">
                                                <td colSpan={7}>موردی یافت نشد</td>
                                            </tr>
                                        );
                                    }
                                    return pageItems.map(accountFound => {
                                        const depStatus = depositStatus(accountFound.depositReturnDate);
                                        return (
                                        <tr key={accountFound.id}>
                                            <td>
                                                <Link
                                                    to={accountFound.id}
                                                    className="table-row-link"
                                                    onClick={() => {
                                                        this.context.handlePersonId(accountFound.parentId, accountFound.id)
                                                    }}
                                                >
                                                    {accountFound.fullName}
                                                </Link>
                                            </td>
                                            <td>{accountFound.phoneNumber}</td>
                                            <td>{accountFound.nationalCode}</td>
                                            <td>{this.personTypeLabel(accountFound.personType)}</td>
                                            <td>{accountFound.bedLocation || '—'}</td>
                                            <td>
                                                {depStatus === 'overdue' ? (
                                                    <span className="badge bg-danger">گذشته</span>
                                                ) : depStatus === 'soon' ? (
                                                    <span className="badge bg-warning text-dark">نزدیک</span>
                                                ) : accountFound.depositReturnDate ? (
                                                    <span className="badge bg-secondary">{String(accountFound.depositReturnDate).split(' ')[0]}</span>
                                                ) : (accountFound.personType === 'familyGuest' || accountFound.personType === 'otherGuest') ? (
                                                    <span className="badge bg-light text-muted">ندارد</span>
                                                ) : '—'}
                                            </td>
                                            <td>
                                                <div className="table-actions">
                                                    <Link
                                                        to={`${accountFound.id}?edit=1`}
                                                        className="icon-btn"
                                                        title="ویرایش"
                                                        onClick={() => {
                                                            this.context.handlePersonId(accountFound.parentId, accountFound.id)
                                                        }}
                                                    >
                                                        <MdOutlineEdit size={15}/>
                                                    </Link>
                                                    {
                                                        localStorage.getItem('role') === "MANAGER" ?
                                                            <button
                                                                type="button"
                                                                className="icon-btn icon-btn-danger"
                                                                title="حذف"
                                                                onClick={() => {
                                                                    this.setState({selectedAccount: accountFound, showDeleteModal: true})
                                                                }}
                                                            >
                                                                <MdOutlineDeleteOutline size={15}/>
                                                            </button>
                                                            : null
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                        );
                                    });
                                })()
                        }
                        </tbody>
                    </table>
                </div>
                {
                    !this.state.searchLoading && (() => {
                        const filtered = this.filterPeople(this.state.accountFound);
                        const {totalPages, page, total} = paginateItems(
                            filtered, this.state.listPage, this.state.pageSize
                        );
                        return (
                            <>
                                <div className="text-muted small text-center mt-2">از {total} مورد</div>
                                <ListPagination
                                    page={page}
                                    totalPages={totalPages}
                                    onNewPage={(p) => this.setState({listPage: p})}
                                />
                            </>
                        );
                    })()
                }
                <Modal
                    style={{left: "50%", translate: "-50%"}}
                    className={"w-25"}
                    centered={true}
                    show={this.state.showDeleteModal}
                    size={'xl'}
                    onHide={() => this.setState({showDeleteModal : false})}
                >
                    <Modal.Header closeButton={true}>
                        <Modal.Title>حذف شخض</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>آیا از حذف شخض {this.state.selectedAccount.fullName} مطمئن هستید؟</Modal.Body>
                    <Modal.Footer>
                        {/* Cancel button for delete account modal */}
                        <button disabled={this.state.deleteLoading} className="btn btn-light" onClick={() => {this.setState({showDeleteModal: false})}}>لغو</button>

                        {/* Confirm button for deleting account */}
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#dc3545",
                                    color: "black",
                                    ":hover": {backgroundColor: "#a52834", color: "white"}
                                }}
                                disabled={this.state.deleteLoading}
                                onClick={() => {
                                    this.handleDelete(this.state.selectedAccount.id);
                                }}
                            >
                                حذف
                            </Button>
                            {this.state.deleteLoading && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: red[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
    //search
    exportExcel = () => {
        const filtered = this.filterPeople(this.state.accountFound);
        const personTypeLabel = (t) => {
            switch (t) {
                case 'constant': return 'اقامتگر ثابت';
                case 'familyGuest': return 'بستگان درجه یک';
                case 'otherGuest': return 'متفرقه';
                default: return t || '';
            }
        };
        downloadCsv('persons.csv', ['نام', 'تلفن', 'کد ملی', 'نوع اقامت', 'موقعیت تخت'], filtered.map((a) => [
            a.fullName,
            a.phoneNumber,
            a.nationalCode,
            personTypeLabel(a.personType),
            a.bedLocation || '',
        ]));
    }

    enrichBedLocations = async (accounts, requestId) => {
        const list = Array.isArray(accounts) ? accounts : [];
        const headers = this.authHeaders();
        const enriched = await Promise.all(list.map(async (account) => {
            if (requestId !== this.searchRequestId) {
                return {...account, bedLocation: ''};
            }
            if (!account?.parentId) {
                return {...account, bedLocation: ''};
            }
            try {
                const person = await axios.get(`${API_BASE_URL}/api/v1/supervisor/person/${account.parentId}`, {headers}).then(r => r.data);
                if (!person?.bed) {
                    return {...account, bedLocation: ''};
                }
                const bed = await axios.get(`${API_BASE_URL}/api/v1/supervisor/bed/${person.bed}`, {headers}).then(r => r.data);
                const room = await axios.get(`${API_BASE_URL}/api/v1/supervisor/room/${bed.room}`, {headers}).then(r => r.data);
                const unit = await axios.get(`${API_BASE_URL}/api/v1/supervisor/unit/${room.unit}`, {headers}).then(r => r.data);
                return {
                    ...account,
                    bedLocation: `واحد ${unit.number} / اتاق ${room.number} / تخت ${bed.name}`,
                };
            } catch (e) {
                return {...account, bedLocation: ''};
            }
        }));
        // فقط اگر همین درخواست هنوز معتبر است، لیست را عوض کن (جلوگیری از بازنویسی نتیجه سرچ)
        if (requestId !== this.searchRequestId) return;
        this.setState({accountFound: enriched});
    }

    handleSearchInput = (e) => {
        const value = e.target.value;
        this.setState({searchInput: value, listPage: 1});
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            const q = (value || '').trim();
            if (!q) {
                this.loadPeople('');
                return;
            }
            const param = encodeURIComponent(q);
            this.loadPeople(`&${this.state.searchType}=${param}`);
        }, 350);
    }
    async handleDelete(charId) {
        this.setState({deleteLoading: true})

        let respondChar = ''
        await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => {
                respondChar = data
            }).catch(async () => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => {
                                        respondChar = data
                                    })
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })


        await axios.delete(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.delete(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        await axios.delete(`${API_BASE_URL}/api/v1/supervisor/person/${respondChar.parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.delete(`${API_BASE_URL}/api/v1/supervisor/person/${respondChar.parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        this.setState({deleteLoading: false, showDeleteModal: false, searchInput: ''})
        this.loadPeople('')
    }

}

export default SearchAccount;